// extracted by mini-css-extract-plugin
export default {"bp-large":"1025px","cardContainer":"Card-module__cardContainer___2rsSt","cardContent":"Card-module__cardContent___3WXpJ","responsive":"Card-module__responsive___2vDR7"};